import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RechercheDxFormuleDto } from '@lexi-clients/lexi';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { FormuleListResult } from '../models/formule-list';
import { IGridService } from '../models/igrid-service';

@Injectable({ providedIn: 'root' })
export class FormuleListService implements IGridService<RechercheDxFormuleDto> {
  baseUrl: string;

  constructor(private http: HttpClient, envService: EnvironmentService) {
    this.baseUrl = envService.environment.baseServiceUrl;
  }

  get(params: HttpParams): Observable<FormuleListResult> {
    return this.http.get<any>(`${this.baseUrl}/api/Formules/recherche-devexpress`, { params: params });
  }

  getById(formuleId: number): Observable<RechercheDxFormuleDto> {
    return this.http.get<any>(`${this.baseUrl}/api/Formules/recherche-devexpress/${formuleId}`);
  }

  post(valeur: RechercheDxFormuleDto): Observable<any> {
    return null;
  }

  put(valeur: RechercheDxFormuleDto): Observable<any> {
    return null;
  }

  delete(valeur: RechercheDxFormuleDto): Observable<any> {
    return null;
  }
}
